import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=90eb315e&scoped=true&lang=pug"
import script from "./ServiceInformation.vue?vue&type=script&lang=ts"
export * from "./ServiceInformation.vue?vue&type=script&lang=ts"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&id=90eb315e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eb315e",
  null
  
)

export default component.exports